<template>
  <div class="my-4 rounded-lg border-2 border-yellow-500 px-4 py-2">
    <div class="grid grid-cols-4 md:grid-cols-2">
      <div class="col-span-3 flex flex-col items-start md:col-span-1">
        <h3 class="text-left text-1md text-dark-gray">
          {{ carrier.legal_name }}
        </h3>
        <small class="text-left text-1md text-body-color">{{
          identifiers
        }}</small>
      </div>
      <button
        class="max-w-max justify-self-end"
        @click="deleteSearch"
      >
        <img
          class="relative inline h-7 w-7"
          src="@/assets/trash-dark-icon.svg"
          alt="delete"
        />
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SearchedCarrierCard',
  props: {
    carrier: {
      type: Object,
      require: true,
    },
  },
  emits: ['delete-search'],
  data() {
    return {};
  },
  computed: {
    identifiers() {
      const identifiersList = this.carrier.identifiers.map((identifier) => {
        return `${identifier.is_type}# ${identifier.value}`;
      });
      return identifiersList.join(' ');
    },
  },
  async created() {},
  methods: {
    deleteSearch() {
      this.$emit('delete-search');
    },
  },
};
</script>
<style scoped></style>
